import React from 'react'
import { useCallback, useRef, useState } from 'react'
import { GoogleMap, MapInitProps, useMapProps } from '../types'

const useMapInit = ({ mapType, mapTypeControl, zoom, center }: useMapProps): MapInitProps => {
    const mapRef = useRef<HTMLDivElement>(null)
    const [mapObject, setMapObject] = useState<GoogleMap>()

    const initMap = useCallback((): void => {
        if (mapRef.current) {
            setMapObject(
                new google.maps.Map(mapRef.current, {
                    mapTypeControl: mapTypeControl,
                    streetViewControl: false,
                    zoom: 12,
                    rotateControl: false,
                    scaleControl: true,
                    fullscreenControl: false,
                    panControl: false,
                    zoomControl: true,
                    gestureHandling: 'cooperative',
                    mapTypeId: mapType,
                    draggableCursor: 'pointer',
                })
            )
        }
    }, [mapType, mapTypeControl])

    React.useEffect(() => {
        if (!mapObject) initMap()
    }, [initMap, mapObject])

    React.useEffect(() => {
        if (mapObject) {
            if (center) mapObject.setCenter(center)
            if (zoom) mapObject.setZoom(zoom)
        }
    }, [center, mapObject, zoom])

    return {
        mapRef,
        mapObject,
    }
}
export default useMapInit
